module.exports = __webpack_public_path__ + "img/uploading.e85a160b.svg";